<template>
  <div class="page">
    <div class="container-en">
      <div class="box1" style="margin-top:10px">
        <div class="itemTitleLayout" style="display:flex;    align-items: center;"> <div style="width:2px;height:15px;background:#82e24d;margin-right:8px"></div> 线路信息</div>
        <div class="activityLayout">
          <img v-lazy="activityDetailData.image" alt="">
          <div class="activityDescLayout">
            <p style="font-size:0.28rem; color:#333;font-weight:500;">{{activityDetailData.title}}</p>
            <p v-if="activityDetailData && activityDetailData.tags" style="font-size:0.20rem; color:#64b572;">{{JSON.parse(activityDetailData.tags).join(' ')}}</p>
          </div>
        </div>
      </div>
      

      <div class="horizontalLineLayout"></div>

      <div class="box1">
        <div class="itemTitleLayout" style="display:flex;    align-items: center;"> <div style="width:2px;height:15px;background:#82e24d;margin-right:8px"></div> 报名须知</div>
        <div class="noticeLayout" style="font-size:13px" v-html="activityDetailData.notice"></div>
      </div>
      

      <div class="horizontalLineLayout"></div>

      <div class="box1">
        <div class="itemTitleLayout" style="display:flex;    align-items: center;"> <div style="width:2px;height:15px;background:#82e24d;margin-right:8px"></div> 出团日期</div>
        <yd-cell-group>
          <yd-cell-item arrow @click.native="showCalendar=true">
            <span slot="left">选择日期</span>
            <span slot="right">{{dateTime}}&nbsp;&nbsp;</span>
          </yd-cell-item>
        </yd-cell-group>
      </div>
    
      <div class="horizontalLineLayout"></div>

      <div class="box1">
        <div class="itemTitleLayout" style="display:flex;    align-items: center;"> 
          <div style="width:2px;height:15px;background:#82e24d;margin-right:8px"></div> 
           <span>报名人员</span> 
           <span style="margin-left:auto;display:flex;align-items: center;font-size:14px" @click="copyFlag = true"> <img src="./assets/img/copy.png" alt="" style="width:15px;margin-right:5px;font-size:14px"> 粘贴名单</span>
          </div>
          <div class="teamGo" v-if="activityDetailData.teamGo">
            <div class="teamGo-btn" :class="selectTeamGo == index?'active':''"   @click="selectTeamGo = index" v-for="(item,index) in activityDetailData.teamPersonNum" :key="index">
              {{item.num}}人
            <div class="you_xia" v-if="selectTeamGo == index">
               <!-- <svg t="1596436018596" class="icon" viewBox="0 0 1024 1024"  version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2067" width="20" height="20"><path d="M256 1024h768V256l-768 768z m493.6-108.8L704 960l-45.6-45.6L576 832l45.6-45.6L704 869.6l210.4-210.4 45.6 45.6-210.4 210.4z" p-id="2068"></path></svg> -->
              <svg t="1596436018596" class="icon" viewBox="0 0 1024 1024" color="#7CAAFE" fill="#7CAAFE" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2067" width="20" height="20"><path d="M256 1024h768V256l-768 768z m493.6-108.8L704 960l-45.6-45.6L576 832l45.6-45.6L704 869.6l210.4-210.4 45.6 45.6-210.4 210.4z" p-id="2068"></path></svg>
            </div>
            </div>
          </div>
        <div v-for="(item, index) in personArray" :key="index" class="enrollUsers">
          <yd-accordion>
            <yd-accordion-item style="font-weight:bold" :title="'第'+(index+1)+'个报名人员'" open>
              <!-- <div class="lineLayout"></div> -->
              <div style="font-weight:normal" v-for="(info, idx) in personArray[index]" :key='idx'>
              <div v-if="info.t2 == 2">
                <div style="display: flex;padding-left: .24rem;height: 40px;align-items: center;border-bottom: 1px solid #ececec;">
                  <span style="color: #555;margin-right: 10px;">{{info.t3}}</span>
                  <van-checkbox @change="checkInfo(info)" v-model="info.isCheck" shape="square"></van-checkbox>
                </div>
                
                 
                  <!-- <van-checkbox v-model="checked">复选框</van-checkbox> -->
                  <!-- <yd-checkbox slot="left" v-model="info.isCheck"  @click="checkInfo(info)"><span style="font-size:.28rem;">{{info.t3}}</span></yd-checkbox> -->
                </div>
                <yd-cell-item v-else>
                  <span slot="left">{{info.t3}}：</span>
                  <yd-input slot="right" v-model="info.fillValue" placeholder=""></yd-input>
                </yd-cell-item>
                <!-- <div class="lineLayout"></div> -->
              </div>
              <div class="deleteButtonLayout">
                <button @click="deleteEnrollerAction(index)">删除</button>
              </div>
            </yd-accordion-item>
          </yd-accordion>
          <!-- <div class="lineLayout"></div> -->
        </div>
        <div class="addEnrollerButtonLayout">
          <button @click="addEnrollerAction">添加报名人员</button>
        </div>
      </div>

      
    </div>
    <div class="bottomBarLayout">
      <div class="lineLayout"></div>
      <div class="textLayout">
        <p style="font-size:12px">{{discountDesc}}</p>
        <p style="font-weight:bold">
          总价：¥{{totalPrice}} &nbsp;&nbsp;&nbsp;&nbsp; 应付：<span style="color:red; font-size:18px">¥{{needPay}}</span>
          <!-- <span v-if="totalPrice - "></span> -->
        </p>
      </div>
      <button @click="submitOrderAction">确认提交</button>
    </div>

    <yd-popup v-if="actId" v-model="showCalendar" position="bottom" width="100%">
      <div style="background-color:#fff;">
        <event-calendar v-bind:actId=actId
                        v-bind:clickDate=clickDate 
                        @getDateInfoFromCalendar="getEnrollDateInfo">
        </event-calendar>
      </div>
    </yd-popup>

    <!-- 粘贴 -->
    <van-dialog class="copy-text" v-model="copyFlag" title="粘贴名单" show-cancel-button @confirm="sendCopyText">
      <div class="box" style="padding:20px;box-sizing:border-box">
        <textarea style="white-space: pre-line;width:100%" placeholder="请在此处粘贴名单，格式如下：戴博1   15989387919   360425201008013715
戴博,  15989387918,  420984198511070311"  v-model="copyText" name="" id="" cols="40" rows="10"></textarea>
      </div>
      
    </van-dialog>

    <van-popup v-model.trim="choosePayFlag" round>
      <div class="choosePay" style="width:300px">
        <div class="title">订单支付</div>
        <div class="pay-list">
          <van-radio-group v-model.trim="payType">
            <van-cell-group>
              <van-cell  clickable @click="payType = '2'">
                <template #title>
                  <img src="./assets/img/wechat1.png" alt="" style="width:30px;height:30px">
                  <span>微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="2" />
                </template>
              </van-cell>
              <van-cell  clickable @click="payType = '1'">
                <template #title>
                  <img src="./assets/img/alipay.png" alt="" style="width:30px;height:30px">
                  <span>支付宝支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="pay-btn" @click="appPay()">去付款</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import appService from '@/services/request/appService'
import wechatService from '@/services/request/wechatService'
import clientService from '@/services/request/clientService'
import EventCalendar from '@/pages/common/EventCalendar'
import store from 'store'
import { Checkbox, CheckboxGroup,Dialog } from 'vant';
export default {
  name: "Enroll",
  components: {
    EventCalendar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]:Dialog
  },
  data() {
    return {
      mine:{},
      actId:'',
      clickDate:'',
      dateTime:'',
      activityDetailData:{},
      needInfoArray:[],  
      personArray:[],
      flag:0,
      discountDesc:'',
      totalPrice: 0,
      needPay:0,
      channel:'join_act',
      enrollersInfoJson:'',
      showCalendar: false,
      copyFlag:false,
      copyText:'',
      choosePayFlag:false,
      appPayOrderId:'',
      payType:'2',
      clientBridge:'',
      selectTeamGo:0,
      errMsg:''

    }
  },
  mounted:function() {
    this.clientInit()
    this.$nextTick(function() {
      document.title = '报名'
      // this.mine = store.get('mine')
      if(this.$route.query.date) {
        this.clickDate = this.$route.query.date
        this.dateTime = this.convertTimeStampToDate(this.clickDate)
      }
      this.activityDetailData = store.get('activityDetailDataCache')
      this.actId = this.activityDetailData.id
      console.log('activityDetailData',this.activityDetailData)
      this.activityDetailData.notice = this.stringReplaceAllMark(this.activityDetailData.notice, '\n','<br/>')
      this.wechatInit()
      this.loadNeedInfo(()=>{
        this.wechatInit(() => {
            this.getUserPermissionScope(() => {
                // this.showBottomBar = this.mine.permission > 0 ? true : false
                // this.shareConfig()
                // this.creatShortUrl()
            })
        })
      })
    })
  },
  methods: {
    getAge(UUserCard) {
        //获取年龄
        var myDate = new Date();
        var month = myDate.getMonth() + 1;
        var day = myDate.getDate();
        var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
        if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
            age++;
        }
        
        return age
    },
    getBirthdayFromIdCard(idCard) {//根据身份证计算生日格式1997-00-00
      var birthday = "";
      if(idCard != null && idCard != ""){
        if(idCard.length == 15){
          birthday = "19"+idCard.substr(6,6);
        } else if(idCard.length == 18){
          birthday = idCard.substr(6,8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
      }
      return birthday;
    },
    async sendCopyText(){
      // console.log('sendtext',this.enrollUsers)
      // let user = objectAssign({}, this.tpl_enrollUser)
      console.log('this.policyHolder',this.policyHolder)
      console.log('user',this.InsuredList)
      // return
      if(this.copyText == ''){
        this.$toast.fail('请输入名单')
        return
      }
      console.log('personArray',this.personArray)
      let result = await  appService.sendCopyText({content:this.copyText});
          console.log('result',result)
          // if(result.code == 0){
          if(!!result.length){
            result.forEach((el,i)=>{
              el = JSON.parse(JSON.stringify(el))
                let ages = this.getAge(el.idCode)
                let adult = 1
                if(ages<18){
                  adult = 2
                }
              console.log(el)
              this.personArray.push(
                [
                  {
                    code: 0,
                    fillValue: el.name,
                    msg: "成功",
                    t1: "name",
                    t2: 1,
                    t3: "姓名",
                  },
                  {
                    code: 0,
                    fillValue: el.idCode,
                    msg: "成功",
                    t1: "idcard",
                    t2: 1,
                    t3: "身份证/证件",
                  },
                  {
                    code: 0,
                    fillValue: el.phone,
                    msg: "成功",
                    t1: "phone",
                    t2: 1,
                    t3: "手机号码",
                  },
                  {
                    code: 0,
                    fillValue: "",
                    msg: "成功",
                    t1: "remark",
                    t2: 1,
                    t3: "备注",
                  },
                  {
                    code: 0,
                    isCheck: adult == 1?false:true,
                    msg: "成功",
                    t1: "isChild",
                    t2: 2,
                    t3: "是否儿童",
                  }
                ]
              )
              
            })
            this.copyFlag = false
            this.calculateOrderHandle()
            console.log('              this.personArray')
          }else{
            // this.loading.close()
            // this.$message.error(result.msg);
          }
      // }else{
      //   this.$toast.fail(result.msg);
      // }
        
    },
    convertTimeStampToDate(timeStamp) {
      timeStamp *= 1.0
      var date = new Date(timeStamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    loadNeedInfo() {
      appService
        .getEnrollNeedInfos({
          detailId: this.activityDetailData.id,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:'',
        })
        .then(data => {
          this.needInfoArray = data
          if ( typeof callback === "function" ) callback()
        }, error => {
          if(error && error.msg) {
            this.$dialog.toast({
              mes: error.msg,
              timeout: 1500,
              icon: 'error',
            });
          }
        })
    },
    wechatInit(callback) {
        if(this.$page.isInWechat){
          wechatService.auth(this.$route.query.iid, ({
            openid, unionid
          }) => {
            console.log(777)
              if(!!openid && !!unionid) {
                  this.mine.unionId = unionid
                  this.mine.openId = openid
              }
              if ( typeof callback === "function" ) callback()
          }, true)
        }else{
          if ( typeof callback === "function" ) callback()
        }
        
    },
    getUserPermissionScope(callback) {
      if(this.$page.isInWechat){
        appService
            .getUserIdentity({
                iid: this.$route.query.iid?this.$route.query.iid:this.mine.iid,
                rid: 0,
                unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
                saleIid:this.$route.query.saleIid?this.$route.query.saleIid:'',
                })
            .then(data => {
                if(data && data.permission) {
                    var permissionInfo = data.permission
                    this.mine.permission = permissionInfo.op
                    // this.mine.u = data.u
                }
                if ( typeof callback === "function" ) callback()
            }, error => {
                var errorStr = '加载失败'
                if(error && error.msg) {
                    errorStr = error.msg
                }else if(error && error.sub_msg) {
                    errorStr = error.sub_msg
                }
                this.$dialog.toast({
                    mes: errorStr,
                    timeout: 1500,
                    icon: 'error',
                });
            })
      }else{
        if ( typeof callback === "function" ) callback()
      }
        
    },
    stringReplaceAllMark: function(str, originWords, updateWords) {
      var reg = new RegExp(originWords, "g"); //创建正则RegExp对象   
      return str.replace(reg, updateWords);
    },
    addEnrollerAction() {
      this.personArray.push(this.deepCopy(this.needInfoArray))
      this.calculateOrderHandle()
    },
    deleteEnrollerAction(index) {
      this.personArray.splice(index, 1)
      this.calculateOrderHandle()
    },
    checkInfo(info) {
      //针对点击操作响应两次的特殊处理
      // this.flag++
      // if(this.flag >= 2) {
      //   this.flag = 0
      //   info.isCheck = !info.isCheck
      //   this.calculateOrderHandle()
      // } 
      this.calculateOrderHandle()     
    },
    getEnrollDateInfo(dateItem) {
      this.showCalendar = false
      this.dateTime = this.convertTimeStampToDate(dateItem.date)
      this.calculateOrderHandle()   
    },
    calculateOrderHandle() {
      var userInfoArray = []
      for(var i = 0; i < this.personArray.length; i++) {
        var infoDic = {}
        var infos = this.personArray[i]
        for(var k = 0; k < infos.length; k++) {
          var info = infos[k]
          if(info.t2 == 2) {
            infoDic[info.t1] = info.isCheck ? true : false;
          }else {
            infoDic[info.t1] = info.fillValue ? info.fillValue : '';
          }
        }
        userInfoArray.push(infoDic)
      }
      this.enrollersInfoJson = JSON.stringify(userInfoArray)
      var date = new Date(this.dateTime)
      var timeStamp = date.getTime()
      appService.calculateOrder({
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          detailId: this.activityDetailData.id,
          joinDate: timeStamp,
          userInfos: this.enrollersInfoJson,
          iid: this.$route.query.iid?this.$route.query.iid:'',
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:'',
        })
        .then(data => {
          console.log('data',data)
          if(data.code == 0) {
            this.errMsg = ''
            if(data.t2) {
              var t2Dic = data.t2
              this.totalPrice = t2Dic.t1
              this.needPay = t2Dic.t2
            }
            if(data.t1) {
              this.discountDesc = data.t1
            }
          }else{
            console.log(666)
            this.errMsg = data.msg
            this.$dialog.toast({
              mes: data.msg,
              timeout: 1500,
              icon: 'error',
            });
          }
        }, error => {
          if(error && error.msg) {
            this.$dialog.toast({
              mes: error.msg,
              timeout: 1500,
              icon: 'error',
            });
          }
        }).catch(error=>{
          if(error && error.msg) {
            this.$dialog.toast({
              mes: error.msg,
              timeout: 1500,
              icon: 'error',
            });
          }
        })
    },
    submitOrderAction() {
      var userInfoArray = []
      console.log('this.personArray',this.personArray)
      let flag = false
      if(this.activityDetailData.teamGo){
        let maxNumber = this.activityDetailData.teamPersonNum[this.selectTeamGo].num
        if(this.personArray.length != maxNumber){
           this.$toast(`当前小包团模式，您选择了${maxNumber}人团，请完善${maxNumber}位报名人信息！`, { isAndroid: false });
          return;
        }
      }
      this.personArray.forEach((item,index)=>{
        item.forEach((el,i)=>{
          console.log(el)
          if(i<=2){
            if(!el.fillValue){
              this.$toast(`请将第${index + 1}个人的${el.t3}填写完整！`)
              // console.log(`请将第${index + 1}个人的${el.t3}填写完整！`)
              flag = true
              throw Error(); 
            }
          }
        })
        if(flag) return
      })
      if(flag) return
      for(var i = 0; i < this.personArray.length; i++) {
        var infoDic = {}
        var infos = this.personArray[i]
        for(var k = 0; k < infos.length; k++) {
          var info = infos[k]
          if(!!info.t2 && (info.t2 == 2)) {
            infoDic[info.t1] = info.isCheck ? true : false;
          }else {
            infoDic[info.t1] = info.fillValue ? info.fillValue : '';
          }
        }
        userInfoArray.push(infoDic)
      }
      this.enrollersInfoJson = JSON.stringify(userInfoArray)
      var date = new Date(this.dateTime)
      var timeStamp = date.getTime()
      if(this.$page.isInApp){

      }else{
        this.$dialog.loading.open('提交中');
      }
      
      appService
        .submitOrder({
          iid: this.$route.query.iid?this.$route.query.iid:this.mine.iid,
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          detailId: this.activityDetailData.id,
          joinDate: timeStamp,
          userInfos: this.enrollersInfoJson,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          if(data && data.t1) {
            var propStr = JSON.stringify(data.t1)
            if(data.t2 && data.t2.t2 == 0){
              this.$dialog.toast({
                mes: '报名成功',
                timeout: 1500,
                icon: 'success',
              });
              this.$dialog.loading.close()
              return
              
            }else{
              if(this.errMsg){
                this.$dialog.toast({
                  mes: this.errMsg,
                  timeout: 1500,
                  icon: 'success',
                });
              }
              this.$dialog.loading.close()
            }
            this.createOrder(propStr);
          }
        }, error => {
          this.$dialog.loading.close()
          if(error && error.msg) {
            this.$dialog.toast({
              mes: error.msg,
              timeout: 1500,
              icon: 'error',
            });
          }
        })
    },
    createOrder(propStr) {
      appService
        .createOrder({
            iid: this.$route.query.iid?this.$route.query.iid:this.mine.iid,
            orderType: 30,
            userId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,                
            name: '',
            phone: '', 
            property: propStr,
            keys: this.activityDetailData.id,
            saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''       
        })
        .then(
            data => {
                this.payOrder(data);
            }, err => {
                this.$dialog.loading.close()
                if(err && err.msg) {
                  this.$dialog.toast({
                    mes: err.msg,
                    timeout: 1500,
                    icon: 'error',
                  });
                }
            }
        );
    },
    async clientInit() {
      let that = this;
      return new Promise((resolve, reject) => {
        // debugger
        if (this.$page.isInApp) {
          clientService.auth((bridge, userInfo) => {
            //获取jsbridge
            this.clientBridge = bridge;
            // alert(JSON.stringify(userInfo));
            if (!!userInfo) {
              // that.publicData.iid = userInfo.iid;
              // that.publicData.rid = userInfo.rid;
              // that.publicData.uid = userInfo.uid;
              resolve(true);
            }
          });
        } else {
          resolve(false);
        }
      });
    },
    appPay(){
      this.$dialog.loading.open('提交中');
      this.$toast(this.clientBridge)
      if(this.clientBridge){
       this.clientBridge.callHandler("thirdPayOrder", {
          orderId: this.appPayOrderId,
          orderType:3,
          payWay:this.payType
        }, function () {});
      }
    },
    payOrder(orderId) {
      if(this.$page.isInApp){
        this.appPayOrderId = orderId
        this.choosePayFlag = true
        return
      }
      var self = this;
      var tradeType = "JSAPI";
      appService
        .createWechatOrder({
            iid: this.$route.query.iid?this.$route.query.iid:this.mine.iid,
            rid: 0,
            session: this.activityDetailData.id,
            gid: orderId,
            channel: this.channel,
            tradeType: tradeType,
            openid: this.mine.openId,
            saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(
            data => {
                this.$dialog.loading.close()
                console.log("orderData:"+JSON.stringify(data));
                wechatService.pay({ data, cb: self.wxPayCallback });
            },
            err => {
                this.$dialog.loading.close()
                if(err && err.msg) {
                  this.$dialog.toast({
                    mes: err.msg,
                    timeout: 1500,
                    icon: 'error',
                  });
                }
            }
        );
    },
    wxPayCallback(retStr) {
        var self = this;
        if (retStr == "success") {
          this.$dialog.toast({
            mes: '支付成功',
            timeout: 1500,
            icon: 'success',
          });
          setTimeout(() => {
            this.$router.push({
              path: '/m/activity/enrollers',
              query: {
                actId: this.activityDetailData.id
              }
            })
          }, 1500);
        } else if (retStr == "cancel") {
            this.$dialog.toast({
              mes: '支付失败：用户取消订单',
              timeout: 1500,
              icon: 'error',
            });
        } else if (retStr == "error") {
          this.$dialog.toast({
            mes: '支付失败：未知错误',
            timeout: 1500,
            icon: 'error',
          });
        } else {
          this.$dialog.toast({
            mes: '支付失败：'+retStr,
            timeout: 1500,
            icon: 'error',
          });
        }
    },
    deepCopy(source) {
      //对象深拷贝
      if(this.isArray(source)) {
        var result = []
        for(var i = 0; i < source.length; i++) {
          var obj = source[i]
          result.push(this.deepCopy(obj))
        }
        return result
      }else {
        var result = {}
        for(var key in source) {
          result[key] = typeof source[key] === 'object' ? this.deepCopy(source[key]) : source[key];
        }
        return result;
      }
    },
    isArray(value) {
      //判断对象是否为数组
      if (typeof Array.isArray === "function") {
        return Array.isArray(value);
      }else {
        return Object.prototype.toString.call(value) === "[object Array]";
      }
    }
  }
}
</script>

<style scoped lang="less">
.teamGo{
    display: flex;
    padding: 10px 8px;
    background: #fff;
  .teamGo-btn{
    width: 67px;
    height: 29px;
    background: #FAFAFA;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right:15px;
    position: relative;
    overflow: hidden;
    &.active{
      border: 1px solid #7CAAFE;
      color: #7CAAFE;
      background: #EFF4FF;
    }
    .you_xia{
      position: absolute;
      right: -1px;
      bottom: -1px;
      width: 21px;
      height: 20px;
      border-radius: 0 0px 9px 0;
      overflow: hidden;
      svg{
        width:100%;
        height:100%
      }
    }
  }
}
.page {
  font-size: 0.28rem;
  height: 100%;
  overflow: hidden;
}
.enrollUsers{
  & /deep/ {
    .yd-cell-item{
      height: 40px;
      input{
        height: 40px!important;
      }
      .yd-cell-right{
      min-height: 40px!important;
      input{
        text-align: right;
      }
    }
    }
    .yd-cell-right{
      min-height: 40px!important;
    }
    .yd-input{
      min-height: 40px;
      input{

        text-align: right;
      }
    }
    input{
      height: 40px!important;
    }
    // .yd-cell-left{
    //     height: 50px;
    //   }
    // .yd-cell-item{
    //   height: 40px;
    //   .yd-cell-right{
    //     height: 40px;
    //     overflow: hidden;
    //   }
    //   .yd-cell-left{
    //     height: 50px;
    //   }
    //   .yd-input{
    //     height: 40px;
    //     & /deep/
    //     input{
    //       height: 40px!important;
    //       line-height: 40px;
    //       // margin-top: -10px;
    //     }
    //   }
    // }
    // .yd-checkbox{
    //   // margin-top: 10px;
    // }
    .yd-accordion-head:after {
        height: 1px;
        position: absolute;
        z-index: 0;
        bottom: 0;
        left: 0;
        content: "";
        width: 95%;
        left: 50%;
        transform: translateX(-50%);
        background-image: -webkit-gradient(linear,left bottom, left top,color-stop(50%, #ececec),color-stop(0, transparent));
        background-image: linear-gradient(0deg,#ececec 50%,transparent 0);
    }
    .yd-cell-item{
      display: flex;
      justify-content: space-between;
      .yd-input{
        input{
          text-align: right;
        }
      }
    }
    .yd-cell-item::after{
          content: "";
          width: 95%;
          height: 1px;
          left: 50%;
          transform: translateX(-50%);
          height: 1px;
          position: absolute;
          z-index: 0;
          bottom: 0;
          background-image: linear-gradient(0deg,#ececec 50%,transparent 0)
    }
    .yd-cell-item:not(:last-child):after{
      width: 90%;
      height: 1px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  // & /deep/ .yd-cell-right{
  //   height: 40px;
  //   overflow: hidden;
  // }
  & /deep/ .yd-cell-right{
      min-height: 40px!important;
    }
  & /deep/ input{
    height: 40px!important;
    text-align: right;
  }
}
.yd-checkbox{
  width: 100%;
}
.horizontalLineLayout{
  width:100%; 
  height:5px; 
  background-color:#f1f1f1;
}
.container-en{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin-bottom: 50px;
  padding-bottom: 20px; 
  -webkit-overflow-scrolling: touch!important;
  overflow-y: scroll!important;
  background-color: #f6f6f6;
  padding: 0 10px;
  box-sizing: border-box;
}
.itemTitleLayout{
  font-size: 16px;
  padding: 8px 8px;
  color: #333;
  background: #fff;
  font-weight: 500;
  padding-bottom: 0;
}
.activityLayout{
  display: flex;
  background-color: white;
}
.activityLayout img{
  margin: 12px;
  width: 90px;
  height: 60px;
}
.activityLayout .activityDescLayout{
  padding: 4px 0;
  margin: auto 0px;
  margin-right: 8px;
}
.noticeLayout{
  padding: 12px;
  background-color:white; 
}
.addEnrollerButtonLayout{
  width: 100%;
  padding: 8px;
  // margin-top: 8px;
  // margin-bottom: 20px;
  background: #fff;
}
.addEnrollerButtonLayout button{
  /* position: absolute; */
  left: 16px;
  padding: 6px 12px;
  text-align: center;
  border-width: 1px;
  border-color:gray;
  font-size: 12px;
  border-radius: 4px;
}
.deleteButtonLayout{
  height: 30px;
  margin-bottom: 12px;
  margin-left: calc(100% - 90px);
  margin-top: 12px;
}
.deleteButtonLayout button{
  width: 70px;
  padding: 4px 12px;
  text-align: center;
  border-width: 1px;
  border-color:gray;
  font-size: 12px;
  border-radius: 4px;
}
.lineLayout{
  height: 1px;
  width: 96%;
  background-color: #f6f6f6;
}
.bottomBarLayout{
  position: absolute;
  bottom: 0;
  height: 50px;
  width: 100%;
  bottom: 0;
  z-index: 1000;
  background-color: white;
  z-index: 1000;
}
.bottomBarLayout .textLayout{
  padding: 6px 12px;
  float: left;
  width: 76%;
}
.bottomBarLayout .textLayout p{
  white-space: nowrap;
  text-overflow: ellipsis; 
  overflow: hidden;
}
.bottomBarLayout button{
  float: right;
  position: absolute;
  right: 0;
  border: none;
  background-color:#19B507;
  color: white;
  font-size: 26px;
  width: 24%;
  height: 100%;
  font-size: 16px;
}
.box1{
  border-radius: 10px;
  overflow: hidden;
  & /deep/ .yd-cell-box{
    margin-bottom: 0;
  }
}
.choosePay{
  width:250px;
  height:300px;
  border-radius:20px;
  padding:20px;
  box-sizing: border-box;
  .title{
    font-size: 18px;
    font-weight: 500;
    height:40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pay-btn{
    height: 35px;
    font-size: 16px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #06b4fd;
    margin-top: 40px;
  }
  .pay-list{
    padding-top:25px;
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }
    .van-cell{
      padding: 15px 16px;
    }
    .van-cell__title{
      display: flex;
      align-items: center;
      span{
        margin-left:10px
      }
    }
  }
}
</style>

<style lang="less">
.choosePay{
  .pay-list{
    .van-cell{
      display: flex;
      align-items: center;
    }
  }
}
</style>
